import { ReactNode } from "react"
import { twMerge } from "tailwind-merge"
import { bodyDefaultSyles } from "./BodyDefault"
import { bodyDefaultLightStyles } from "./BodyDefaultLight"

type FontWeightStyle = "bodyDefaultSyles" | "bodyDefaultLightStyles"

const fontStyleMap = {
  bodyDefaultSyles,
  bodyDefaultLightStyles,
} satisfies Record<FontWeightStyle, string>

interface BaseListProps {
  fontWeightSyles?: FontWeightStyle
  listItems: ReactNode[]
  className?: string
}

const BaseList = ({
  as: Tag,
  fontWeightSyles = "bodyDefaultSyles",
  listItems,
  className,
}: BaseListProps & { as: "ul" | "ol" }) => {
  const listTypeClass = Tag === "ul" ? "list-disc" : "list-decimal"
  return (
    <Tag className={twMerge(fontStyleMap[fontWeightSyles], listTypeClass, "list-inside", className)}>
      {listItems.map((item, i) => (
        <li className="list-item" key={`list-${i}`}>
          {item}
        </li>
      ))}
    </Tag>
  )
}

export const UnorderedList = (props: BaseListProps) => <BaseList as="ul" {...props} />
export const OrderedList = (props: BaseListProps) => <BaseList as="ol" {...props} />
